import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@onefootprint/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SandboxToggle from '@/components/sandbox-toggle';
type ComposerEnvSelectorProps = {
  /** Omit to read the org session, for surfaces that don't track an environment of their own. */
  value?: 'sandbox' | 'production';
  /** Omit to render locked: the surface shows which environment it runs in but can't change it. */
  onChange?: (value: 'sandbox' | 'production') => void;
  lockedTooltip?: string;
  disabled?: boolean;
};
const ComposerEnvSelector = t0 => {
  const $ = _c(17);
  const {
    value,
    onChange,
    lockedTooltip,
    disabled
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "form"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("ask-percy", t1);
  const isLocked = !onChange;
  const [isOpen, setIsOpen] = useState(false);
  let t2;
  if ($[1] !== t || $[2] !== value) {
    t2 = value === "sandbox" ? t(_temp) : t(_temp2);
    $[1] = t;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = isLocked || disabled || isOpen;
  const t4 = disabled || isLocked;
  let t5;
  if ($[4] !== isLocked || $[5] !== lockedTooltip || $[6] !== t) {
    t5 = isLocked ? lockedTooltip ?? t(_temp3) : undefined;
    $[4] = isLocked;
    $[5] = lockedTooltip;
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== onChange || $[9] !== t4 || $[10] !== t5 || $[11] !== value) {
    t6 = <SandboxToggle value={value} onChange={onChange} disabled={t4} disabledTooltip={t5} onOpenChange={setIsOpen} labelClassName="text-caption-2" className="w-auto [&_button]:h-7! max-md:[&_button]:h-8! [&_button]:w-auto! [&_button]:border-none! [&_button]:bg-transparent! [&_button]:px-1.5! [&_button]:shadow-none! [&_button:hover]:bg-hover! [&_button>div:last-child]:ml-1! [&_button>span]:max-w-none!" />;
    $[8] = onChange;
    $[9] = t4;
    $[10] = t5;
    $[11] = value;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t6) {
    t7 = <Tooltip side="top" align="start" content={t2} disabled={t3}>{t6}</Tooltip>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default ComposerEnvSelector;
function _temp($) {
  return $.sandboxOn;
}
function _temp2($_0) {
  return $_0.sandboxOff;
}
function _temp3($_1) {
  return $_1.sandboxLocked;
}